import { appPath, workAreaRoutePath } from '@featit/shared/addressing/paths';

export function projectDashboardPagePath(
  projectSlug: string | null | undefined,
  pageId: string | null | undefined,
): string {
  if (!pageId) return projectSlug ? workAreaRoutePath(projectSlug) : appPath('/home');
  const page = ['pages', pageId];
  return projectSlug ? workAreaRoutePath(projectSlug, page) : appPath(page);
}

/**
 * The page a path is showing, or null where it is showing none (F-0201). Read from the URL rather
 * than from a router param, so the sidebar can answer it without being inside the page's route.
 */
export function dashboardPageIdFromPath(pathname: string): string | null {
  const match = /\/pages\/([^/?#]+)/.exec(pathname);
  return match ? decodeURIComponent(match[1]) : null;
}

const EDIT_DASHBOARD_PAGE_PARAM = 'edit';

export function projectDashboardPageEditPath(
  projectSlug: string | null | undefined,
  pageId: string,
): string {
  const params = new URLSearchParams();
  params.set(EDIT_DASHBOARD_PAGE_PARAM, pageId);
  return `${projectDashboardPagePath(projectSlug, pageId)}?${params.toString()}`;
}

export interface DashboardPageNavigationState {
  editDashboardPageId?: string;
}

export function dashboardPageEditNavigationState(pageId: string): DashboardPageNavigationState {
  return { editDashboardPageId: pageId };
}

export function shouldOpenDashboardPageEditor(
  state: unknown,
  pageId: string | null | undefined,
  search = '',
): boolean {
  if (!pageId) return false;
  if (new URLSearchParams(search).get(EDIT_DASHBOARD_PAGE_PARAM) === pageId) return true;
  if (!state || typeof state !== 'object' || Array.isArray(state)) return false;
  return (state as DashboardPageNavigationState).editDashboardPageId === pageId;
}

export function clearDashboardPageEditSearch(search: string): string {
  const params = new URLSearchParams(search);
  params.delete(EDIT_DASHBOARD_PAGE_PARAM);
  const next = params.toString();
  return next ? `?${next}` : '';
}

/**
 * An item-scoped page opened for one item (F-0621 AGM-42): `…/pages/<pageId>/items/<key>`. The page
 * part is the page's own path, so everything that reads the page from the URL still finds it.
 */
export function projectDashboardPageItemPath(
  projectSlug: string | null | undefined,
  pageId: string,
  itemKey: string,
): string {
  const route = ['pages', pageId, 'items', itemKey];
  return projectSlug ? workAreaRoutePath(projectSlug, route) : appPath(route);
}
